import { Component, OnInit } from '@angular/core';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Observable } from 'rxjs';
import { Genre } from 'src/models/genre';
import { ActivatedRoute } from '@angular/router';
import { PodcastService } from 'src/app/services/podcast.service';
import { Stream } from 'src/models/stream';
import { Country } from 'src/models/country';

@Component({
  selector: 'app-podcast-countries',
  templateUrl: './podcast-countries.component.html',
  styleUrls: ['./podcast-countries.component.scss']
})
export class PodcastCountriesComponent implements OnInit, ListStreamsI {
  state$: Observable<object>;

  public countries = new Array<Country>();

  public countryId: string;

  constructor(private activatedRoute: ActivatedRoute, private podcastService: PodcastService) {}

  ngOnInit() {
    this.podcastService.getCountries().subscribe((value: Country[]) => {
      this.countries = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.countryId = params['id'];
    });
  }

  public getHeadline(): string {
    const category = this.countries.find((country: Country) => country.id === this.countryId);

    return category !== undefined ? category.name : 'Alle';
  }
  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const page = (start / itemsPerPage) + 1;
    const observable = this.countryId !== undefined ? this.podcastService.getTopPodcastsByCountry(this.countryId, page)
                                                    : this.podcastService.getTopPodcasts(page);

    return observable;
  }

}